import React from 'react';

export default function Modal({ showModal, setShowModal, children }) {
  if (!showModal) return null;
  return (
    <div className="modal-container" onClick={() => setShowModal(false)}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        {children}
        <button type="button" className="close" onClick={() => setShowModal(false)}>
          Close
        </button>
      </div>
    </div>
  );
}
